import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient/ata/documentos-ata/documentos/editor-texto/DocumentoEditorTextoApiClient'

export default {
	async [actionTypes.ATA.DOCUMENTOS_ATA.DOCUMENTOS.EDITOR_TEXTO.ADICIONAR](context, dados) {
		const { data } = await api.adicionarDocumento(dados)
		return data
	},

	async [actionTypes.ATA.DOCUMENTOS_ATA.DOCUMENTOS.EDITOR_TEXTO.REDIGIR](context, idDocumento) {
		const { data } = await api.redigir(idDocumento)
		return data
	},

	async [actionTypes.ATA.DOCUMENTOS_ATA.DOCUMENTOS.EDITOR_TEXTO.VISUALIZAR](context, idDocumento) {
		const { data } = await api.visualizar(idDocumento)
		return data
	},

	async [actionTypes.ATA.DOCUMENTOS_ATA.DOCUMENTOS.EDITOR_TEXTO.SINCRONIZAR](context, idDocumento) {
		const { data } = await api.sincronizar(idDocumento)
		return data
	},
	async [actionTypes.ATA.DOCUMENTOS_ATA.DOCUMENTOS.EDITOR_TEXTO.BUSCAR_POR_ID](context, idDocumento) {
		const { data } = await api.buscarPorId(idDocumento)
		return data
	},
}
